<template>
  <div class="questionnaire">

    <el-tabs
        v-loading="loadBtn"
        v-model="activeName"
        v-if="questionnaire != null"
        :stretch="true">

      <el-tab-pane
          :label="item.title"
          :name="item.id.toString()"
          v-for="item of questionnaire"
          :key="item.id"
      >
        <!-- <div class="questionnaire__description" v-if="item.description">{{ item.description }}</div> -->

        <el-table
            :data="answers[item.id]"
            :show-header="false"
            style="width: 100%">
          <el-table-column prop="text">
            <template slot-scope="scope">
              <span style="font-size: 15px">{{ scope.row.text }}</span>
            </template>
          </el-table-column>

          <el-table-column
              align="right">
            <template slot-scope="scope">
              <div v-if="scope.row.type === $staticData.questionnaire.rowType.radio">
                <el-radio name="yes" :style="{marginRight: '0'}" v-model="scope.row.answer.answer_bool" :label="true"
                          border>Да
                </el-radio>
                <el-radio name="no" v-model="scope.row.answer.answer_bool" :label="false" border>Нет</el-radio>
              </div>
              <div v-else-if="scope.row.type === $staticData.questionnaire.rowType.tag">
                <el-radio name="yes" :style="{marginRight: '0'}" v-model="scope.row.answer.answer_bool" :label="true"
                          border>Да
                </el-radio>
                <el-radio name="no" v-model="scope.row.answer.answer_bool" :label="false" border>Нет</el-radio>
              </div>
              <div v-else-if="scope.row.type === $staticData.questionnaire.rowType.select">
                <el-select
                    name="answer_select"
                    style="width: 100%"
                    v-model="scope.row.answer.answer_select"
                    multiple
                    :multiple-limit="scope.row.multiselect ? 20 : 1"
                    value-key="key"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Введите значение"
                    :remote-method="remoteMethod"
                    class="questionnaire__select"
                    @blur="clearOptions"
                    @focus="editCompendium(scope.row.compendium)"
                    :loading="loading"
                >
                  <el-option
                      v-for="item in listItem(scope.row.compendium)"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div v-else-if="scope.row.type === $staticData.questionnaire.rowType.number">
                Ввод числа
              </div>
              <div v-else>
                Тип вопроса не поддерживается
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 25px; float: right;">
          <el-button @click="submitCard(activeName)" name="submitCard" :loading="loadBtn">Сохранить анкету</el-button>
        </div>

      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "questionnaire",
  data() {
    return {
      answers: [],
      loading: false,
      loadBtn: false,
      options: {},
      card: "",
      questionnaire: null,
      error: null,
      cardId: null,
      activeCompendium: {},
      activeName: 0,
      dirs: {}
    };
  },
  props: {
    type: {
      type: Number
    }
  },
  created() {
    this.loadLogic();
  },
  computed: {
    ...mapGetters("session", {session: "session"}),
  },
  methods: {
    listItem(compendium) {
      return Object.assign(
          this.dirs[compendium] ? this.dirs[compendium] : {},
          this.options[compendium] ? this.options[compendium] : {}
      )
    },
    loadLogic() {
      let params = {
        params: {
          search: this.type
        }
      }
      this.loadBtn = true

      this.$api.questionnaire
          .get(this.session.id, params)
          .then((response) => {

            this.questionnaire = response.data
            this.cardId = this.questionnaire.id

            let dirs = {};

            this.activeName = (response.data[0].id).toString()

            response.data.forEach((questionnaire) => {
              let struct = []
              questionnaire.questions.forEach(question => {
                if (questionnaire.user_questionnaire !== undefined) {
                  let answer = questionnaire.user_questionnaire.question_answer.find(
                      answer => answer.question_id === question.id
                  )

                  if (answer) {
                    if (answer.compendium_item)
                      answer.answer_select = answer.compendium_item.map(item => item.id);
                    if (question.compendium && answer.compendium_item) {

                      let dirsItem = (dirs[question.compendium]) || {}
                      answer.compendium_item.forEach(item => {
                        dirsItem[item.id] = item
                      })
                      dirs[question.compendium] = dirsItem
                    }

                  } else answer = this.defaultAnswers(question.id)
                  question.answer = {...answer}
                } else
                  question.answer = {...this.defaultAnswers(question.id)}
                struct.push({...question});
              })

              this.answers[questionnaire.id] = struct
              this.dirs = dirs

            })
          })
          .catch((res) => {
            this.$notify.error({
              title: "Ошибка 😕",
              message: res.response.data.message,
            })
          })
          .finally(() => {
            this.loadBtn = false;
            this.$emit('onLoad')
          });
    },
    defaultAnswers(questionId) {
      return {
        question_id: questionId,
        answer_bool: null,
        answer_text: null,
        answer_select: []
      }
    },
    clearOptions() {
      this.options[this.activeCompendium] = [];
    },
    editCompendium(data) {
      this.activeCompendium = data;
    },
    remoteMethod(query) {
      if (query === "")
        return this.options[this.activeCompendium] = []

      this.loading = true

      let params = {
        params: {
          search: query,
          short: !!1,
          limit: 25,
          page: 1,
        },
      };

      this.$api.questionnaire
          .compendium(this.activeCompendium, params)
          .then((response) => {
            let options = {}
            response.data.forEach(item => options[item.id] = item)
            this.options[this.activeCompendium] = options
          })
          .catch(() => {
            this.options[this.activeCompendium] = []
          })
          .finally(() => {
            this.loading = false
          })
    },
    goBack() {
      this.$router.push({
        name: "session.device",
      })
    },
    submitCard(cardId) {
      let question_answer = []

      // todo Дима
      this.answers[cardId].forEach(item => {
        if (item.answer.answer_bool !== undefined ||
            item.answer.answer_text !== undefined ||
            item.answer.answer_select !== undefined) {
          question_answer.push({
            question_id: item.answer.question_id,
            ...(item.answer.answer_bool != undefined && {answer_bool: item.answer.answer_bool}),
            ...(item.answer.answer_select && {compendium_link: item.answer.answer_select}),
          })
        }
      })

      let question = this.questionnaire.find(
          answer => answer.id == cardId
      )

      let idQuestionnaire = question.user_questionnaire ? question.user_questionnaire.id : false
      this.loadBtn = !!1;

      this.$api.questionnaire.send(
          idQuestionnaire ? 'update' : 'post',
          this.session.id,
          idQuestionnaire,
          {
            questionnaire_id: cardId, // id анкеты
            question_answer // ответы
          }
      ).then(() => {
        this.$notify.success({
          title: "Удачно!",
          message: "Данные анкеты были " + (idQuestionnaire ? 'обновлены' : 'сохранены'),
        });
      }).catch((res) => {
        this.$notify.error({
          title: "Упс..",
          message: res.response.data.message,
        })
      }).finally(() => {
        this.loadBtn = !!0;
      })
    },

  },
}
</script>

<style scoped lang="scss">
.box-card {
  padding: 20px;

  &__title {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.box-header {
  &__button {
    float: right;
    padding: 3px 0;
  }
}

.questionnaire {
  width: calc(100% - 20px);
  border: 0;
  border-radius: 8px;
  box-shadow: none;
  padding: 10px;
  background: #fff;
  margin-left: 0;

  &-select {
    width: 100%;
  }

  &__row {
    margin: 10px 0;
  }

  &__title {
    padding-top: 6px;
  }

  &__choice {
    text-align: end;

    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }

  &__description {
    line-height: 1.8;
    font-size: 12px;
    padding: 18px 24px;
    background-color: #fafafa;
    border: 1px solid #eaeefb;
    margin-bottom: 25px;
    border-radius: 4px;
  }
}

.el-tabs {
  /deep/ {
    .el-tabs__header {
      display: none;
    }

  }
}


.questionnaire .questionnaire__select {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;

  &__select .el-tag__close {
    top: 0 !important;
  }

  .el-tag {
    white-space: pre-line;
    text-align: left;
    position: relative;

    overflow: hidden;
    display: -webkit-box;

    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding-right: 20px;
  }

  .el-tag__close {
    position: absolute;
    right: 4px;
    top: 3px;
  }

  .el-tag--small {
    height: auto;
    padding: 4px 8px;
  }
}


// todo возможно стоит вынести в общие стили для всего проекта
.el-radio {

  &.is-bordered.is-checked {
    border-color: #43D3B3 !important;
    background: #43D3B3;


  }


  /deep/ {
    .el-radio__input {
      display: none;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #fff !important;
    }

    .el-radio__label {
      padding: 5px 10px !important;
      font-weight: 500;
      font-size: 12px;
    }

    .el-radio--mini {


      &.is-bordered {
        padding: 6px 10px 0 10px;

      }


    }


  }


}
</style>
